/**
 * Created by eliza on 18/5/8.
 */

var Domain = BASE_URL;

var channel;
var ua = navigator.userAgent.toLowerCase();
if(ua.match(/MicroMessenger/i)=="micromessenger") {
  channel = 'WECHAT';
} else {
  channel = 'WAP';
}
var requestParam = (vm)=>`?access_token=${localStorage.getItem('access_token')}&channel=${channel}`;
var channelParam = '?channel='+channel;


var api = {
    account: {
        login: function() {
            "use strict";
            return Domain + '/eSolverOmniChannel/account/login.do';
        }
    },
    b2c: {
      singlePrice() {
        return Domain + '/b2csearch/esapi/product/pricepromotion';
      }
    },
    search: {
      findPdpPath() {
        return BASE_URL  + '/services/sonystyle/pdp/search?channel=mobile&sku=';
      },
      findPDP() {
        return BASE_URL  + '/services/sonystyle/detail/search?path=';
      },
      index() {
        return BASE_URL  + '/services/sonystyle/index/search?index=0&channel=mobile'
      },
      category() {
        return BASE_URL  + '/services/sonystyle/category/search';
      },
      list() {
        return BASE_URL  + '/services/sonystyle/list/search';
      },
      filter() {
        return BASE_URL  + '/services/sonystyle/filter/search?path=';
      }
    },
    product: {
        //产品主数据
        findMasterData: function() {
            "use strict";
            return Domain + '/pim/out?method=findMasterData'
        },
        //产品特征
        findMainSpec: function() {
            "use strict";
            return Domain + '/pim/out?method=findMainSpec'
        },
        //产品特征详情
        findDetailSpec: function() {
            "use strict";
            return Domain + '/pim/out?method=findDetailSpec'
        },
        //产品配件
        findProductAccessory: function() {
            "use strict";
            return Domain + '/pim/out?method=findProductAccessory'
        },
        //产品比较
        findDetailSpecCompare: function() {
          "use strict";
          return Domain + '/pim/out?method=findDetailSpecCompare'
        },
        //比较列表
        findCompareList: function() {
          "use strict";
          return Domain + '/pim/out?method=findCompareList'
        }
    },
    basket: {
        addToBasket: function(vm) {
            "use strict";
          console.log(vm)
            return Domain + '/eSolverOmniChannel/order/addToBasket.do' + requestParam(vm);
        },
        addFlashBuyToBasket: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/addFlashBuyToBasket.do' + requestParam(vm);
        }
    },
    cart: {
        readCart: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/readCart.do' + requestParam(vm);
        },
        changeCart: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/changeCart.do' + requestParam(vm);
        },
        miniCart: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/miniCartDisplay.do' + requestParam(vm);
        },
        moveToWishlist: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/wishlist/moveToWishlist.do' + requestParam(vm);
        },
        checkout: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/checkout.do' + requestParam(vm);
        },
    },
    wishlist: {
      addToWishList(vm) {
        return Domain + '/eSolverOmniChannel/wishlist/addWishlistEntry.do' + requestParam(vm);
      }
    },
    promotion: {
      getCartPromotions(vm) {
        return Domain + '/eSolverOmniChannel/coupon/getCartPromotions.do' + requestParam(vm);
      }
    },
    order: {
       getOrder: function(vm) {
           "use strict";
           return Domain + '/eSolverOmniChannel/order/getOrder.do' + requestParam(vm);
       },
        alipay: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/alipayOnlinePayment.do' + requestParam(vm);
        },
        getOldOrder: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/getOldOrder.do' + requestParam(vm);
        },
        createOrder: function(vm) {
            "use strict";
            return Domain + '/eSolverOmniChannel/order/createOrder.do' + requestParam(vm);
        },
    },
    review: {
      getProductReviews: function() {
            return Domain + '/eSolverOmniChannel/review/getProductReviews.do' + channelParam;
        }
    },
    coupon: {
      getItemCouponList(vm) {
        return Domain + '/eSolverOmniChannel/coupon/getItemCouponList.do' + requestParam(vm);
      },
      applyCoupon:(vm)=> `${Domain}/eSolverOmniChannel/coupon/applyCoupon.do${requestParam(vm)}`,
      removeCoupon:(vm)=> `${Domain}/eSolverOmniChannel/coupon/releaseCoupon.do${requestParam(vm)}`
    },
    address: {
      getAddress: (vm) => `${Domain}/eSolverOmniChannel/address/getShipToAddress.do${requestParam(vm)}`
    },
    common:{}
};

/**
 * get the channel, we have WEB,WAP,WECHAT,APP
 * 
 */
api.common.checkChannel=()=>{

    //I'd like to put something here,to check the user agent
    return "WAP";

}


export default api;



// WEBPACK FOOTER //
// ./src/base/api.js